export const ActionTypes = {
  SET_ALL_MALLS: 'SET_ALL_MALLS',
  SET_ALL_MALLS_USERS: 'SET_ALL_MALLS_USERS',
  SET_ALL_STORES: 'SET_ALL_STORES',
  SET_ALL_STORES_GROUP: 'SET_ALL_STORES_GROUP',
};
